import styleConstants from "../../styleConstants";

const tableStyles = {
  cell: {
    whiteSpace: "nowrap"
  },
  center: {
    textAlign: "center"
  },
  container: {
    width: "min-content"
  },
  currentYear: {
    backgroundColor: styleConstants.colors.themeBluePale
  },
  groupEnd: {
    borderRight: `1px solid ${styleConstants.colors.gray3}`
  },
  groupStart: {
    borderLeft: `1px solid ${styleConstants.colors.gray3}`
  },
  heading: {
    paddingTop: "0.75rem",
    borderBottom: `1px solid ${styleConstants.colors.gray5}`,
    verticalAlign: "bottom",
    fontSize: "0.75rem",
    fontWeight: styleConstants.fontWeights.bold,
    textTransform: "uppercase"
  },
  majorGroupEnd: {
    borderRight: `1px solid ${styleConstants.colors.gray5}`
  },
  majorGroupStart: {
    borderLeft: `1px solid ${styleConstants.colors.gray5}`
  },
  right: {
    textAlign: "right"
  },
  row: {
    borderTop: `1px solid ${styleConstants.colors.gray3}`
  },
  superTitle: {
    borderBottom: `1px solid ${styleConstants.colors.gray3}`
  },
  table: {
    width: "100%",
    borderCollapse: "collapse",
	fontSize: "0.875rem",
	"& td, & th": {
		padding: "0.5rem"
	}
  },
  title: {
    fontSize: "0.75rem",
    fontWeight: styleConstants.fontWeights.bold,
    textTransform: "uppercase"
  },
  totalColumn: {
    backgroundColor: styleConstants.colors.themeBluePale
  },
  totalRow: {
    borderTop: `1px solid ${styleConstants.colors.gray5}`,
    fontWeight: styleConstants.fontWeights.bold
  }
};

export default tableStyles;
